module.exports = __webpack_public_path__ + "static/media/preloader-bar.d74f5d92.gif";